import { setClient } from '../../redux/client/action'
import { saveClient } from '../../utils/storage'

export default dispatch => ({
  setClient: person => {
    saveClient(person)
    dispatch(setClient(person))
  }
})
